const styles = (theme) => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    cursor: "none !important",

    alignItems: "center",
    flexDirection: "column",
    position: "relative",
    backgroundColor: "rgba(225, 221, 217, 0.94)",
  },
  p: {
    cursor: "none !important",
    color: "#575452",
    fontSize: "21px",
    padding: "15px",
    lineHeight: "26px",
    letterSpacing: "0.02em",
    fontFamily: "Aktiv Grotesk",
    "&:hover": {
      color: "#0045EA",
    },
    fontWeight: 600,
    textDecoration: "none",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
      fontSize: "1rem",
      lineHeight: "1rem",
    },
  },
  closeIcon: {
    cursor: "none !important",

    position: "absolute",
    top: "40px",
    right: "60px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
      top: "18px",
      right: "10px",
    },
  },
  rotate: {
    animation: "rotateOnView 1s forwards",
  },
  pActive: {
    color: "#0045EA",
  },
});

export default styles;